export default __webpack_public_path__ + "static/Gargi-07dd57833d612fbde655fa0044a91d64.jpeg";